module.exports = __webpack_public_path__ + "static/media/faq-1500.a179f1c1.webp";